import CSRF from "./lib/CSRF";
import { TimeEdit } from "./lib/TimeEdit";
import _ from "underscore";
import UnderscoreExt from "./lib/underscore-ext";
import Language from "./lib/Language";
import { createRoot } from "react-dom/client";

/**
 * Create a one instance of a react root container
 */
const appContainerElem = document.getElementById("core-container") as HTMLElement;
export const appRoot = createRoot(appContainerElem);

/**
 * Main application
 */
const loadApp = function () {
    TimeEdit.run();
};

const REQ_READY = 4;
const HTTP_OK = 200;
const TEN_MINS = 10 * 60000;

function updateLoop() {
    const req = new XMLHttpRequest();
    req.onreadystatechange = () => {
        if (req.readyState === REQ_READY) {
            if (req.status === HTTP_OK) {
                const response = req.response.trim();
                if (!response.startsWith("silent") && window.BUILD_NUM !== response) {
                    if (!window.updateRequested) {
                        window.updateRequested = true;
                        // eslint-disable-next-line no-alert
                        if (window.confirm(Language.get("nc_client_update_needed"))) {
                            document.location.reload();
                        }
                    }
                }
            }
        }
    };
    const url = `${window.CDN_HOST}/version`;
    req.open("get", url, false);
    req.send("");
}

setInterval(updateLoop, TEN_MINS);

document.addEventListener("DOMContentLoaded", () => {
    // Extend underscore.js with any custom utility functions we might need
    _.mixin(UnderscoreExt);

    const isSecure = process.env.NODE_ENV !== "development";
    const tokenError = CSRF.updateToken(isSecure);
    if (tokenError) {
        console.log("Token error!", tokenError);
    }

    loadApp();
});
